import { useMineInfo } from '@services/auth'
import envStore from '@shared/env'
import { convertData } from '@shared/innmaxLib/services'
import moment from 'moment'
import { map, mergeAll, pathOr } from 'ramda'
import React from 'react'
import { useAllSessions, type ISession } from '.'

const { compose } = require('ramda')

export const useConvertSessionData = (data: any) => {
  const { dataSource: mineInfo } = useMineInfo()

  return React.useMemo(() => {
    if (!data) {
      return {}
    }
    const mySessions = pathOr<ISession[]>([], ['sessionInfos'], mineInfo)

    const dataSource = convertData<ISession>({
      converter: (x: any) => {
        return {
          ...x,
          imageFileUrl: `${envStore.uploadFileUrlPrefix}${x.imageFilePath}`,
          layerFileUrl: `${envStore.uploadFileUrlPrefix}${x.layerFilePath}`,
          createdAt: moment(x.createdAt),
          createdAtStr: moment(x.createdAt).format('YYYY/MM/DD HH:mm:ss'),
          hasPermission:
            mineInfo?.allSessionPermission ||
            mySessions.filter(s => s.id === x.id).length > 0,
        }
      },
    })(data)

    let _data = pathOr([], ['content'], dataSource)

    let byId: { [key: string]: ISession } = compose(
      mergeAll,
      map((x: ISession) => ({ [x.id]: x }))
    )(_data)

    return {
      byId,
      data: _data as ISession[],
      dataSource,
    }
  }, [data, mineInfo])
}

/**
 * 取得縣市行政區域的 Session 資料
 * @param data
 */
export const useConvertParkingLotFullSession = () => {
  const { byId, isFetched } = useAllSessions()

  const converter = React.useCallback(
    (data: any, parkingLotKey: string = 'parkingLotSessionId') => {
      if (!data || !isFetched) {
        return {
          parkingLotSession: null,
          distSession: null,
          citySession: null,
        }
      }

      const parkingLotSession = byId[data[parkingLotKey]]
      if (parkingLotSession?.sourceType !== 'parkingLot') {
        return {
          parkingLotSession: null,
          distSession: null,
          citySession: null,
        }
      }
      const distSession = byId[parkingLotSession?.parentSessionId]
      const citySession = byId[distSession?.parentSessionId]

      return {
        parkingLotSession,
        distSession,
        citySession,
      }
    },
    [byId, isFetched]
  )
  return converter
}
